<template>
    <div class="vehicle-visitors d-flex flex-column align-items-center">
        <app-sub-title text="Ingresos de Vehículos" />
        <app-vehicle-visitors-filters
            v-if="clientId"
            v-model="filters"
            :on-filter="onFilter"
            :client-id="clientId"
        />
        <div class="alert alert-info" v-if="!data.data || !data.data.length">
            <h4>No hay información</h4>
        </div>

        <a
            v-if="!!data.data && !!data.data.length"
            :data="data.data"
            :href="downloadUrl"
            target="_blank"
        >
            <i class="fa fa-file-excel-o" aria-hidden="true"></i> Exportar
        </a>

        <app-vehicle-visitors-table
            v-if="!!data.data && !!data.data.length"
            :data="data.data"
        />
        <div
            class="pagination d-flex justify-content-center"
            v-if="!!data.data && !!data.data.length"
        >
            <app-paginator
                v-if="!!data.data"
                :current-page="data.current_page"
                :last-page="data.last_page"
                :total="data.total"
                :from="data.from"
                :to="data.to"
                :on-change-page="onChangePage"
            />
        </div>
    </div>
</template>
<script>
import VehicleVisitorsFilters from '../../../AdminClients/VehicleVisitors/VehicleVisitorsFilters/VehicleVisitorsFilters.vue'
import VehicleVisitorsTable from '../../../AdminClients/VehicleVisitors/VehicleVisitorsTable/VehicleVisitorsTable.vue'
import vehiclesRepository from '../../../../repositories/vehicles.repository'
import Paginator from '../../../UI/Controls/Paginator/Paginator.vue'
export default {
    components: {
        appVehicleVisitorsFilters: VehicleVisitorsFilters,
        appVehicleVisitorsTable: VehicleVisitorsTable,
        appPaginator: Paginator,
    },
    data() {
        return {
            filters: {
                plate: '',
                vehicleTypeId: '',
                vehicleEntryTypeId: '',
                from: '',
                to: '',
                destinationId: '',
                internal: '',
            },
            page: 1,
            data: '',
        }
    },

    watch: {
        clientId(val) {
            this.loadEntries()
        },
    },

    props: {
        clientId: {
            type: Number,
            default: '',
        },
    },
    computed: {
        downloadUrl() {
            const queryString = Object.keys(this.filters)
                .map(key =>
                    !!this.filters[key] ? `${key}=${this.filters[key]}` : false
                )
                .filter(item => !!item)
                .join('&')
            // const join = !!queryString? '?':'';
            const url = `/exports/vehicle-entries/export-excel?client=${this.clientId}&${queryString}`

            return url
        },
    },
    methods: {
        loadEntries() {
            const vr = Object.assign({}, vehiclesRepository)

            vr.getVehicleEntriesByClient(this.clientId, this.page, this.filters)
                .then(data => {
                    this.data = data
                })
                .catch(error => {
                    toastr.error(
                        'Ocurrió un error al cargar la información de ingresos'
                    )
                })
        },
        onChangePage(page) {
            this.page = page
            this.loadEntries()
        },
        onFilter() {
            this.page = 1
            this.loadEntries()
        },
    },
    created() {
        this.loadEntries()
    },
}
</script>
